import epicerie from '../assets/food-icons/epicerie.png';
import salades from '../assets/food-icons/salades.png';
import soupes from '../assets/food-icons/soupes.png';
import petitDejeuner from '../assets/food-icons/petit-dejeuner.png';
import patisseries from '../assets/food-icons/patisseries.png';
import boulangerie from '../assets/food-icons/boulangerie.png';
import glaces from '../assets/food-icons/glaces.png';
import desserts from '../assets/food-icons/desserts.png';
import sucreries from '../assets/food-icons/sucreries.png';
import bubbleTea from '../assets/food-icons/bubble-tea.png';
import smoothies from '../assets/food-icons/smoothies.png';
import boissons from '../assets/food-icons/boissons.png';
import vegan from '../assets/food-icons/vegan.png';
import grillades from '../assets/food-icons/grillades.png';
import barbecue from '../assets/food-icons/barbecue.png';
import poissonsGrilles from '../assets/food-icons/poissons-grilles.png';
import fruitsDeMer from '../assets/food-icons/fruits-de-mer.png';
import ailesDePoulet from '../assets/food-icons/ailes-de-poulet.png';
import fromages from '../assets/food-icons/fromages.png';
import pates from '../assets/food-icons/pates.png';
import hotDogs from '../assets/food-icons/hot-dogs.png';
import burgers from '../assets/food-icons/burgers.png';
import clubSandwich from '../assets/food-icons/club-sandwich.png';
import sandwichs from '../assets/food-icons/sandwichs.png';
import wraps from '../assets/food-icons/wraps.png';
import tacos from '../assets/food-icons/tacos.png';
import burritos from '../assets/food-icons/burritos.png';
import kebabs from '../assets/food-icons/kebabs.png';
import pizza from '../assets/food-icons/pizza.png';
import sushi from '../assets/food-icons/sushi.png';
import thai from '../assets/food-icons/thai.png';
import dimSum from '../assets/food-icons/dim-sum.png';
import poke from '../assets/food-icons/poke.png';
import ramen from '../assets/food-icons/ramen.png';
import indien from '../assets/food-icons/indien.png';
import mediterraneen from '../assets/food-icons/mediterraneen.png';
import platsAfricains from '../assets/food-icons/plats-africains.png';
import snacks from '../assets/food-icons/snacks.png';
import cadeaux from '../assets/food-icons/cadeaux.png';
import cuisineLocale from '../assets/food-icons/cuisine-locale.png';
// Rayons d'épicerie sans équivalent dans le jeu food-icons
import cereales from '../assets/grocery-categories/cereales.png';
import condiments from '../assets/grocery-categories/condiments.png';
import confitures from '../assets/grocery-categories/confitures.png';
import conserves from '../assets/grocery-categories/conserves.png';
import epices from '../assets/grocery-categories/epices.png';
import farines from '../assets/grocery-categories/farines.png';
import huiles from '../assets/grocery-categories/huiles.png';
import infusions from '../assets/grocery-categories/infusions.png';
import legumesSecs from '../assets/grocery-categories/legumes_secs.png';
import legumineuses from '../assets/grocery-categories/legumineuses.png';

function normalize(name) {
  return String(name || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim();
}

// Icônes illustrées des catégories (plats de l'accueil et rayons d'épicerie), par mots-clés
// normalisés (minuscules, sans accents). Ordre = priorité : le plus spécifique d'abord.
const CATEGORY_ICON_MAP = [
  { keywords: ['entree', 'salade'], icon: salades },
  { keywords: ['soupe'], icon: soupes },
  { keywords: ['petit-dejeuner', 'petit dejeuner', 'breakfast'], icon: petitDejeuner },
  { keywords: ['patisserie', 'viennoiserie'], icon: patisseries },
  { keywords: ['boulangerie', 'pain'], icon: boulangerie },
  { keywords: ['glace'], icon: glaces },
  { keywords: ['dessert'], icon: desserts },
  { keywords: ['sucrerie', 'bonbon', 'sucre'], icon: sucreries },
  { keywords: ['bubble'], icon: bubbleTea },
  { keywords: ['smoothie', 'jus'], icon: smoothies },
  { keywords: ['boisson'], icon: boissons },
  { keywords: ['vegetarien', 'vegan', 'vegetal'], icon: vegan },
  { keywords: ['grillade'], icon: grillades },
  { keywords: ['barbecue', 'bbq'], icon: barbecue },
  { keywords: ['poisson'], icon: poissonsGrilles },
  { keywords: ['fruits de mer', 'fruit de mer'], icon: fruitsDeMer },
  { keywords: ['poulet'], icon: ailesDePoulet },
  { keywords: ['fromage'], icon: fromages },
  { keywords: ['pates', 'pate'], icon: pates },
  { keywords: ['hot dog', 'hot-dog'], icon: hotDogs },
  { keywords: ['burger', 'fast-food', 'fastfood', 'fast food'], icon: burgers },
  { keywords: ['club'], icon: clubSandwich },
  { keywords: ['sandwich'], icon: sandwichs },
  { keywords: ['wrap'], icon: wraps },
  { keywords: ['tacos'], icon: tacos },
  { keywords: ['burrito'], icon: burritos },
  { keywords: ['kebab'], icon: kebabs },
  { keywords: ['pizza'], icon: pizza },
  { keywords: ['sushi'], icon: sushi },
  { keywords: ['thai'], icon: thai },
  { keywords: ['dim sum'], icon: dimSum },
  { keywords: ['poke'], icon: poke },
  { keywords: ['ramen', 'asiatique', 'asie'], icon: ramen },
  { keywords: ['indien'], icon: indien },
  { keywords: ['mediterraneen', 'europeen', 'europe'], icon: mediterraneen },
  { keywords: ['africain', 'afrique', 'plat'], icon: platsAfricains },
  { keywords: ['snack'], icon: snacks },
  { keywords: ['cadeau'], icon: cadeaux },
  { keywords: ['local'], icon: cuisineLocale },
  { keywords: ['cereale'], icon: cereales },
  { keywords: ['condiment'], icon: condiments },
  { keywords: ['confiture'], icon: confitures },
  { keywords: ['conserve'], icon: conserves },
  { keywords: ['epice'], icon: epices },
  { keywords: ['farine'], icon: farines },
  { keywords: ['huile'], icon: huiles },
  { keywords: ['infusion', 'tisane', 'the'], icon: infusions },
  { keywords: ['legume sec', 'legumes secs'], icon: legumesSecs },
  { keywords: ['legumineuse'], icon: legumineuses },
];

/**
 * Icône illustrée d'une catégorie de plats ou d'épicerie (nom libre, FR, avec ou sans accents).
 * Retombe sur l'icône épicerie si aucune correspondance (ou si la catégorie est "Tous"/"Autres").
 */
export function getGroceryCategoryIcon(categoryName) {
  const normalized = normalize(categoryName);
  if (!normalized || normalized === 'tous' || normalized === 'autres') {
    return epicerie;
  }
  for (const entry of CATEGORY_ICON_MAP) {
    if (entry.keywords.some((kw) => normalized.includes(kw))) {
      return entry.icon;
    }
  }
  return epicerie;
}

export default getGroceryCategoryIcon;
